import { writable } from 'svelte/store';
import Swal from 'sweetalert2';
const sourceMediaInfo = writable(null);
function initializeMediaInfo() {
    const MediaInfo = window.MediaInfo.default;
    if (!MediaInfo)
        return Swal.fire({
            titleText: 'MediaInfo.js not found',
            text: 'Failing to load "mediainfo.js" means you won\'t be able to upload video files locally',
            icon: 'warning'
        });
    MediaInfo({ format: 'JSON' }, (mi) => {
        sourceMediaInfo.set(mi);
    });
}
export default {
    subscribe: sourceMediaInfo.subscribe,
    initializeMediaInfo
};
